import { render, staticRenderFns } from "./RoleCopy.vue?vue&type=template&id=679de297&scoped=true&"
import script from "./RoleCopy.vue?vue&type=script&lang=js&"
export * from "./RoleCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679de297",
  null
  
)

export default component.exports